export const isValidUrl = (text: string): boolean => {
  const urlPattern = /^https?:\/\/(?:www\.)?(?:[a-zA-Z0-9-]{1,63}\.)+[a-zA-Z]{2,63}\b([a-zA-Z0-9()@:%_+.~#?&//=]*)$/i;
  return urlPattern.test(text);
};
